module.exports = __webpack_public_path__ + "img/umajo-plus@2x.324bc342.png";